import React, { useEffect, useState } from 'react';
import { Button, Menu, MenuItem, Typography } from '@mui/material';
import { firestore } from '../../../../contexts/FirebaseContext';
import { fCurrency } from '../../../../utils/formatNumber';

function WalletUserView({ userId }) {
  const [wallet, setWallet] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const propertyName = (name = '') => {
    switch (name) {
      case 'saldoServicio':
        return 'Saldo de servicio';
      case 'saldoPaqueteria':
        return 'Saldo de paqueteria';
      case 'saldoRecarga':
        return 'Saldo de recarga';

      default:
        return 'Saldo';
    }
  };

  useEffect(() => {
    async function getSaldo() {
      await firestore
        .collection('wallets')
        .doc(userId)
        .onSnapshot((snapshot) => {
          //   console.log(snapshot.data());
          if (snapshot.exists) {
            setWallet(snapshot.data());
          }
        });
    }
    getSaldo();
  }, [userId]);
  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        size="small"
      >
        ver
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {Object.entries(wallet).map((wall, i) => (
          <MenuItem key={i} onClick={handleClose}>
            {propertyName(wall[0])} {fCurrency(wall[1])}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default WalletUserView;

// function BasicMenu() {
//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const open = Boolean(anchorEl);
//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };
//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   return (
//     <div>
//       <Button
//         id="basic-button"
//         aria-controls={open ? 'basic-menu' : undefined}
//         aria-haspopup="true"
//         aria-expanded={open ? 'true' : undefined}
//         onClick={handleClick}
//       >
//         Dashboard
//       </Button>
//       <Menu
//         id="basic-menu"
//         anchorEl={anchorEl}
//         open={open}
//         onClose={handleClose}
//         MenuListProps={{
//           'aria-labelledby': 'basic-button'
//         }}
//       >
//         <MenuItem onClick={handleClose}>Profile</MenuItem>
//         <MenuItem onClick={handleClose}>My account</MenuItem>
//         <MenuItem onClick={handleClose}>Logout</MenuItem>
//       </Menu>
//     </div>
//   );
// }
